import type { PostPreview } from "@/types";
import React, { FC, useRef } from "react";
import { Link } from "../link";
import type { TranslationItem } from "@/translations";
import { A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { PostCard } from "../post-card";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

interface Props {
  title: string;
  viewAll: TranslationItem;
  readMore: string;
  posts: PostPreview[];
  className?: string;
  theme?: "dark" | "light";
}

export const ResourcesLatestPosts: FC<Props> = ({
  title,
  viewAll,
  readMore,
  posts,
  className,
  theme,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section
      className={`resourcesLatestPosts ${
        className || ""
      } resourcesLatestPosts_${theme || "dark"}`}
    >
      <div className="resourcesLatestPosts--inner">
        <div className="wrapper">
          <div ref={ref} className="resourcesLatestPosts--top">
            <SplitTextAnimation
              htmlElement={
                <h2 className="resourcesLatestPosts--title">{title}</h2>
              }
              isInView={isInView}
            />
            {viewAll.link?.uri && (
              <Link
                href={viewAll.link?.uri}
                noStyle
                className="resourcesLatestPosts--viewAll"
              >
                {viewAll.text}
              </Link>
            )}
          </div>
          <div className="resourcesLatestPosts--cards">
            {posts.map((post, index) => {
              return (
                <PostCard
                  key={index}
                  card={post}
                  readMore={readMore}
                  theme={theme}
                />
              );
            })}
          </div>
          <Swiper
            modules={[A11y]}
            spaceBetween={64}
            slidesPerView={2}
            grabCursor
            className="resourcesLatestPosts--swiper"
          >
            {posts.map((slide, index) => {
              return (
                <SwiperSlide
                  key={index}
                  className="resourcesLatestPosts--slide"
                >
                  <PostCard
                    key={index}
                    card={slide}
                    readMore={readMore}
                    theme={theme}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
